import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { upsertCompanyIdentifier, deleteCompanyIdentifier } from "store/state/companies";
import { FormControl, Input } from "@material-ui/core";
import { PrimaryButton, ButtonSizeOptions, ButtonIcon } from '@loanbossinc/component-library';
import styled from "styled-components";


const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  align-content: space-between;
`;

const NewIdentifierControl = styled(FormControl)`
  && {
    width: 392px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
`;

const IdentifierWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: scroll;
  height: 219px;
  width: 393px;
`;

const AddNew = styled.div`
  cursor: pointer;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  float: right;
  margin-bottom: 16px;
  color: #005AA9;
`;
const Identifier = styled.div`&&{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;

  .button-icon{
    width:10px;
    height:10px;
    color:#C4C4C4;
    border-color: #C4C4C4;
  }
}
`;
export class CompanyIdentifiers extends Component {
  state = {
    companyId: null,
    companyIdentifiers: [],
    newIdentifier: "",
    error: {
      atLeastOneRequired: false
    }
  };

  componentDidMount() {
    // this.props.upsertCompanyIdentifier();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { company, companyTypes } = this.props;
    const { companyId } = prevState;
    if (this.shouldRenderDifferentCompany(companyTypes, companyId, company)) {
      this.setState({
        companyId: company.id,
        isLoaded: true
      });
    }
  }

  shouldRenderDifferentCompany = (companyTypes, companyId, company) => companyTypes && companyTypes.length > 0 && companyId !== company.id;

  validate = company => {
    const newError = {
      atLeastOneRequired: false
    };
    this.setState({
      error: newError
    });
  };

  handleValidate = () => {
    const { company } = this.state;
    const companyError = this.validate(company);
    this.setState({
      error: companyError
    });
  };

  handleChange = ({ target: { name, value } }) => {
    this.setState({ newIdentifier: value });
  };

  createPlaceholderDiv = () => <div style={{ width: 375, height: 100 }} />;

  addNewIdentifier = (newIdentifier) => {
    this.props.addCompanyIdentifiers(newIdentifier);
    this.setState({ newIdentifier: "" })
    // this.props.upsertCompanyIdentifier({ companyId: this.props.company.id, newIdentifier, callback: () => { this.setState({ newIdentifier: "" }) } });
  }

  handleDelete = (item) => {
    this.props.removeCompanyIdentifiers(item);
    this.setState({ newIdentifier: "" })
    // this.props.deleteCompanyIdentifier({ companyId: this.props.company.id, id: item.id });
  }

  renderExisting = () => {
    const { company } = this.props;
    console.log('Rerendered', company);

    if (!company || !company.companyIdentifiers) return null;

    return company.companyIdentifiers.map(x => (
      <Identifier>
        <Input type="text" name="identifier" style={{ width: "100%" }} disabled autoFocus value={x.value} />

        <div style={{ float: "right" }}>
          <ButtonIcon
            hasBorder={true}
            iconName="close"
            onClick={() => this.handleDelete(x)}
          />
        </div>
      </Identifier>
    ))
  }
  render() {
    const { error, newIdentifier } = this.state;

    return (
      <Fragment>
        <div style={{ color: "#999cad" }}>Company URL</div>
        <form>
          <FormWrapper>
            <div>
              <div>
                <NewIdentifierControl error={this.state.error.identifier} margin="normal">
                  <Input type="text" name="identifier" onChange={this.handleChange} value={newIdentifier} />
                </NewIdentifierControl>
                <AddNew onClick={() => this.addNewIdentifier(newIdentifier)}>+ Add Company URL</AddNew>
                <IdentifierWrapper>
                  {this.renderExisting()}
                </IdentifierWrapper>
              </div>
            </div>
          </FormWrapper>
        </form>
      </Fragment>
    );
  }
}

CompanyIdentifiers.propTypes = {
  company: PropTypes.object,
  upsertCompanyIdentifier: PropTypes.func.isRequired
};

const mapStateToProps = ({ authentication, companies }) => ({
  authentication,
  companyIdentifiers: companies.companyIdentifiers
});

export default compose(
  connect(
    mapStateToProps,
    { upsertCompanyIdentifier, deleteCompanyIdentifier }
  )
)(CompanyIdentifiers);
